<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="tableColumns" :data="tableData" border @on-sort-change="sortChange" :disabled-hover="true">
            <!-- 资源ID -->
            <template slot-scope="{ row }" slot="resourceId">
                <Tooltip :content="row.tag" :transfer="true" max-width="300">{{row.resourceId }}</Tooltip>
            </template>
            <!-- 账号ID -->
            <template slot-scope="{ row }" slot="accountIdStr">
                <Tooltip :content="row.tag" :transfer="true" max-width="300">{{ row.accountIdStr }}</Tooltip>
            </template>
            <!-- 动态循环的tag -->
            <template slot-scope="{ row,column,index }" :slot="item.slot" v-for="(item,index) in tableColumns.slice(2)">
                <!-- 编辑单元格 -->
                <Input v-model="tableData[index][column.slot]" v-if="selectedCell.rowIndex === index && selectedCell.columnIndex === column.slot" @on-enter="initSelectedCell(row,tableData[index][column.slot],item.slot)" icon="ios-close-circle" @on-click="clickIcon"/>
                <!-- 显示内容 -->
                <div v-else>
                    <Tooltip :content="row.tag" :transfer="true" max-width="300" placement="top">
                        <div @click="editCellData(row,column,index)" :style="((row[item.slot]!='') ?'cursor: pointer;':'cursor: pointer;color:#fff')" >{{ row[item.slot]!='' ? row[item.slot] : '暂无数据' }}</div>
                    </Tooltip>
                </div>
            </template>
        </Table>
        <br/>
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>

<script>
import {getCookie} from '../../../../utils/cookieUtil.js';
let tableResourceTag = {};
export default {
    name: 'TableResourceTag',
    data() {
        return {
            current: 1,
            dataTotal: 0,
            pageSize: 10,
            awsResourceType: '',
            companyId: '',
            accountIds:[],
            company:getCookie(global.companyId),
            selectedCell:{
                columnIndex:'',
                rowIndex:''
            },
            tableColumns:[],
            tableData:[]
        }
    },
    beforeCreate: function () {
        tableResourceTag = this
    },
    methods: {
        // 关闭Input框
        clearInput:function(){
            this.selectedCell.rowIndex='';
            this.selectedCell.columnIndex='';
        },
        initSelectedCell:function(row,val,slot){
            // 单元格数据不输入给默认值
            let columnData = this.selectedCell.columnIndex;
            let rowData = this.selectedCell.rowIndex;
            if (this.tableData[rowData][columnData] == null || this.tableData[rowData][columnData] == '') {
                this.tableData[rowData][columnData] = '';
            }else{
                // 更新资源标签
                this.$api.tag.updateResourceStandardTagValue({
                    "awsResourceType": tableResourceTag.awsResourceType,
                    "accountId": row.accountId,
                    "region": row.region,
                    "resourcePrimaryKeyId": row.resourcePrimaryKeyId,
                    "resourceId":row.resourceId,
                    "tagKey":slot,
                    "tagValue":val
                })
                .then(res => {
                    this.getTableResourceTagData();
                    this.$Message.success('添加成功');
                })
            }
            this.clearInput();
        },
        editCellData:function(row,column,index){
            this.selectedCell.rowIndex = index;
            this.selectedCell.columnIndex = column.slot;
        },
        // 排序
        sortChange:function(){
            this.clearInput();
        },
        // 点击图标
        clickIcon:function(){
            this.clearInput();
            this.getTableResourceTagData();
        },
        // 显示数据
        showAll: function (companyId,accountIds,awsResourceType) {
            tableResourceTag.awsResourceType = awsResourceType;
            tableResourceTag.companyId = companyId;
            tableResourceTag.accountIds = accountIds;
            tableResourceTag.getTableResourceTagData();
        },
        // 根据账号、资源类型、标签查询资源
        getTableResourceTagData: function () {
            tableResourceTag.$api.tag.queryAWSResourceTagsByTagKey({
                "pageNum": this.current,
                "pageSize": this.pageSize,
                "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                "awsResourceType": this.awsResourceType,
                "accountIds":this.accountIds,
            })
            .then(res => {
                this.tableColumns=res.data.tableColumns;
                this.tableData = res.data.tableDatas;
                // 当前页
                tableResourceTag.current = res.data.slPage.current;
                // 总条数
                tableResourceTag.dataTotal = res.data.slPage.total;
                this.clearInput();
            })
        },
        changePage: function (current) {
            this.current = current;
            tableResourceTag.getTableResourceTagData();
        },
        changeSize: function (pageSize) {
            this.pageSize = pageSize;
            tableResourceTag.getTableResourceTagData();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/TableResourceTag.vue